export var RENTAL_SHOP_KIND = 0;
export var COMMISSION_SHOP_KIND = 1;
export var isRentalShop = function (shop) {
    return shop.kind === RENTAL_SHOP_KIND;
};
export var isCommissionShop = function (shop) {
    return shop.kind === COMMISSION_SHOP_KIND;
};
